const mapStateToThis = ({ manageInventory, session, config, dictionary }) => {
  const { locale } = session;
  const { showManifestNumber } = config;
  const { userSelection, orderDetails, orderDetailsLoadingStatus: isLoading } = manageInventory;
  const { orderStatuses } = dictionary;
  const terms = dictionary.terms[locale];

  return {
    locale,
    userSelection,
    orderDetails,
    isLoading,
    showManifestNumber,
    terms,
    orderStatuses,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('gettextCatalog', '$ngRedux', '$state')
class OrderDetailsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.getHeaders();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getHeaders() {
    this.headers = [
      {
        text: this.gettextCatalog.getString('Game Name'),
      },
      {
        text: this.gettextCatalog.getString('Game No.'),
      },
      {
        text: this.gettextCatalog.getString('Price Point'),
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: this.gettextCatalog.getString('{{ pack }} No.', { pack: this.terms.PACK.singular }),
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: this.gettextCatalog.getString('{{ pack }} Value', { pack: this.terms.PACK.singular }),
      },
    ];
  }
}

export default OrderDetailsController;



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-details/order-details.controller.js